export const charactersPalette = {
  cloud: "#F1C40F",
  tifa: "#2ECC61",
  barret: "#E7483E",
  aerith: "#3598DB",
  inventory: "#8561C5",
};

export const cardsPalette = {
  boss: "#F44336",
  encounter: "#FB99BB",
  menu: "#3F51B5",
  pick: "#2D6930",
  pickOptional: "#6FBF73",
  shop: "#FF9800",
  dialogue: "#795548",
  heal: '#2196F3',
  box: '#E65100',
  bench: "#757575",
  break: "#4DB6AC",
};
